import { z } from "zod"

/**
 * String schema for building area / sq ft form fields.
 * Accepts empty string or a non-negative number (validated without coercing).
 * Use for text inputs where the value is kept as string in form state.
 */
export const buildingAreaSchema = z
  .string()
  .trim()
  .default("")
  .refine(
    (val) => val === "" || (!Number.isNaN(Number(val)) && Number(val) >= 0),
    { message: "Must be empty or a non-negative number" }
  )
